/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import {
  ChallengeStatusResponseOutput,
  ContactDeletionResponseOutput,
  ContactPageResponseOutput,
  ContactResponseOutput,
  CurrentVerificationChallengesResponseOutput,
  VerificationResultResponseOutput,
} from '../model';
import type {
  ChallengeInitiateBody,
  ConfirmEmailVerificationBody,
  ContactCreateBody,
  ContactDeleteBody,
  ContactUpdateBody,
  ListContactsParams,
  SmsChallengeConfirmationBody,
} from '../model';

import { validatedFetch } from '../../client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetCurrentVerificationChallengesUrl = (userId: string) => {
  return `/api/v1/users/${userId}/contacts/verification-challenges`;
};

export const getCurrentVerificationChallenges = async (
  userId: string,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<CurrentVerificationChallengesResponseOutput> => {
  return validatedFetch<CurrentVerificationChallengesResponseOutput>(
    getGetCurrentVerificationChallengesUrl(userId),
    {
      ...options,
      method: 'GET',

      schema: CurrentVerificationChallengesResponseOutput,
    },
  );
};

export const getGetCurrentVerificationChallengesQueryKey = (userId: string) => {
  return [`/api/v1/users/${userId}/contacts/verification-challenges`] as const;
};

export const getGetCurrentVerificationChallengesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentVerificationChallenges>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCurrentVerificationChallenges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentVerificationChallengesQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentVerificationChallenges>>> = ({
    signal,
  }) => getCurrentVerificationChallenges(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentVerificationChallenges>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentVerificationChallengesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentVerificationChallenges>>
>;
export type GetCurrentVerificationChallengesQueryError = unknown;

export function useGetCurrentVerificationChallenges<
  TData = Awaited<ReturnType<typeof getCurrentVerificationChallenges>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCurrentVerificationChallenges>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentVerificationChallengesQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListContactsUrl = (userId: string, params?: ListContactsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/users/${userId}/contacts?${stringifiedParams}`
    : `/api/v1/users/${userId}/contacts`;
};

export const listContacts = async (
  userId: string,
  params?: ListContactsParams,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<ContactPageResponseOutput> => {
  return validatedFetch<ContactPageResponseOutput>(getListContactsUrl(userId, params), {
    ...options,
    method: 'GET',

    schema: ContactPageResponseOutput,
  });
};

export const getListContactsQueryKey = (userId: string, params?: ListContactsParams) => {
  return [`/api/v1/users/${userId}/contacts`, ...(params ? [params] : [])] as const;
};

export const getListContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = unknown,
>(
  userId: string,
  params?: ListContactsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listContacts>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListContactsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listContacts>>> = ({ signal }) =>
    listContacts(userId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listContacts>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListContactsQueryResult = NonNullable<Awaited<ReturnType<typeof listContacts>>>;
export type ListContactsQueryError = unknown;

export function useListContacts<TData = Awaited<ReturnType<typeof listContacts>>, TError = unknown>(
  userId: string,
  params?: ListContactsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listContacts>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContactsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateContactUrl = (userId: string) => {
  return `/api/v1/users/${userId}/contacts`;
};

export const createContact = async (
  userId: string,
  contactCreateBody: ContactCreateBody,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<ContactResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<ContactResponseOutput>(getCreateContactUrl(userId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(contactCreateBody),
    schema: ContactResponseOutput,
  });
};

export const getCreateContactMutationKey = () => ['createContact'] as const;

export const getCreateContactMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContact>>,
    TError,
    CreateContactMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContact>>,
  TError,
  CreateContactMutationVariables,
  TContext
> => {
  const mutationKey = getCreateContactMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContact>>,
    CreateContactMutationVariables
  > = (props) => {
    const { userId, data } = props ?? {};

    return createContact(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateContactMutationResult = NonNullable<Awaited<ReturnType<typeof createContact>>>;
export type CreateContactMutationBody = ContactCreateBody;
export type CreateContactMutationError = unknown;
export type CreateContactMutationVariables = { userId: string; data: ContactCreateBody };

export const useCreateContact = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContact>>,
    TError,
    CreateContactMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createContact>>,
  TError,
  CreateContactMutationVariables,
  TContext
> => {
  return useMutation(getCreateContactMutationOptions(options));
};
export const getUpdateContactUrl = (userId: string, contactId: string) => {
  return `/api/v1/users/${userId}/contacts/${contactId}`;
};

export const updateContact = async (
  userId: string,
  contactId: string,
  contactUpdateBody: ContactUpdateBody,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<ContactResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<ContactResponseOutput>(getUpdateContactUrl(userId, contactId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(contactUpdateBody),
    schema: ContactResponseOutput,
  });
};

export const getUpdateContactMutationKey = () => ['updateContact'] as const;

export const getUpdateContactMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContact>>,
    TError,
    UpdateContactMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContact>>,
  TError,
  UpdateContactMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateContactMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContact>>,
    UpdateContactMutationVariables
  > = (props) => {
    const { userId, contactId, data } = props ?? {};

    return updateContact(userId, contactId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateContactMutationResult = NonNullable<Awaited<ReturnType<typeof updateContact>>>;
export type UpdateContactMutationBody = ContactUpdateBody;
export type UpdateContactMutationError = unknown;
export type UpdateContactMutationVariables = {
  userId: string;
  contactId: string;
  data: ContactUpdateBody;
};

export const useUpdateContact = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContact>>,
    TError,
    UpdateContactMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateContact>>,
  TError,
  UpdateContactMutationVariables,
  TContext
> => {
  return useMutation(getUpdateContactMutationOptions(options));
};
export const getDeleteContactUrl = (userId: string, contactId: string) => {
  return `/api/v1/users/${userId}/contacts/${contactId}`;
};

export const deleteContact = async (
  userId: string,
  contactId: string,
  contactDeleteBody: ContactDeleteBody,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<ContactDeletionResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<ContactDeletionResponseOutput>(getDeleteContactUrl(userId, contactId), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(contactDeleteBody),
    schema: ContactDeletionResponseOutput,
  });
};

export const getDeleteContactMutationKey = () => ['deleteContact'] as const;

export const getDeleteContactMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContact>>,
    TError,
    DeleteContactMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContact>>,
  TError,
  DeleteContactMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteContactMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContact>>,
    DeleteContactMutationVariables
  > = (props) => {
    const { userId, contactId, data } = props ?? {};

    return deleteContact(userId, contactId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContact>>>;
export type DeleteContactMutationBody = ContactDeleteBody;
export type DeleteContactMutationError = unknown;
export type DeleteContactMutationVariables = {
  userId: string;
  contactId: string;
  data: ContactDeleteBody;
};

export const useDeleteContact = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContact>>,
    TError,
    DeleteContactMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteContact>>,
  TError,
  DeleteContactMutationVariables,
  TContext
> => {
  return useMutation(getDeleteContactMutationOptions(options));
};
export const getInitiateUrl = (userId: string, contactId: string) => {
  return `/api/v1/users/${userId}/contacts/${contactId}/challenges`;
};

export const initiate = async (
  userId: string,
  contactId: string,
  challengeInitiateBody: ChallengeInitiateBody,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<ChallengeStatusResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<ChallengeStatusResponseOutput>(getInitiateUrl(userId, contactId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(challengeInitiateBody),
    schema: ChallengeStatusResponseOutput,
  });
};

export const getInitiateMutationKey = () => ['initiate'] as const;

export const getInitiateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof initiate>>,
    TError,
    InitiateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof initiate>>,
  TError,
  InitiateMutationVariables,
  TContext
> => {
  const mutationKey = getInitiateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof initiate>>,
    InitiateMutationVariables
  > = (props) => {
    const { userId, contactId, data } = props ?? {};

    return initiate(userId, contactId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InitiateMutationResult = NonNullable<Awaited<ReturnType<typeof initiate>>>;
export type InitiateMutationBody = ChallengeInitiateBody;
export type InitiateMutationError = unknown;
export type InitiateMutationVariables = {
  userId: string;
  contactId: string;
  data: ChallengeInitiateBody;
};

export const useInitiate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof initiate>>,
    TError,
    InitiateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof initiate>>,
  TError,
  InitiateMutationVariables,
  TContext
> => {
  return useMutation(getInitiateMutationOptions(options));
};
export const getStatusUrl = (userId: string, contactId: string, challengeId: string) => {
  return `/api/v1/users/${userId}/contacts/${contactId}/challenges/${challengeId}`;
};

export const status = async (
  userId: string,
  contactId: string,
  challengeId: string,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<ChallengeStatusResponseOutput> => {
  return validatedFetch<ChallengeStatusResponseOutput>(
    getStatusUrl(userId, contactId, challengeId),
    {
      ...options,
      method: 'GET',

      schema: ChallengeStatusResponseOutput,
    },
  );
};

export const getStatusQueryKey = (userId: string, contactId: string, challengeId: string) => {
  return [`/api/v1/users/${userId}/contacts/${contactId}/challenges/${challengeId}`] as const;
};

export const getStatusQueryOptions = <TData = Awaited<ReturnType<typeof status>>, TError = unknown>(
  userId: string,
  contactId: string,
  challengeId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStatusQueryKey(userId, contactId, challengeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof status>>> = ({ signal }) =>
    status(userId, contactId, challengeId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      userId !== null &&
      userId !== undefined &&
      contactId !== null &&
      contactId !== undefined &&
      challengeId !== null &&
      challengeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData> & { queryKey: QueryKey };
};

export type StatusQueryResult = NonNullable<Awaited<ReturnType<typeof status>>>;
export type StatusQueryError = unknown;

export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = unknown>(
  userId: string,
  contactId: string,
  challengeId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getStatusQueryOptions(userId, contactId, challengeId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getConfirmSmsUrl = (userId: string, contactId: string, challengeId: string) => {
  return `/api/v1/users/${userId}/contacts/${contactId}/challenges/${challengeId}/confirm`;
};

export const confirmSms = async (
  userId: string,
  contactId: string,
  challengeId: string,
  smsChallengeConfirmationBody: SmsChallengeConfirmationBody,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<VerificationResultResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<VerificationResultResponseOutput>(
    getConfirmSmsUrl(userId, contactId, challengeId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(smsChallengeConfirmationBody),
      schema: VerificationResultResponseOutput,
    },
  );
};

export const getConfirmSmsMutationKey = () => ['confirmSms'] as const;

export const getConfirmSmsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSms>>,
    TError,
    ConfirmSmsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmSms>>,
  TError,
  ConfirmSmsMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmSmsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmSms>>,
    ConfirmSmsMutationVariables
  > = (props) => {
    const { userId, contactId, challengeId, data } = props ?? {};

    return confirmSms(userId, contactId, challengeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmSmsMutationResult = NonNullable<Awaited<ReturnType<typeof confirmSms>>>;
export type ConfirmSmsMutationBody = SmsChallengeConfirmationBody;
export type ConfirmSmsMutationError = unknown;
export type ConfirmSmsMutationVariables = {
  userId: string;
  contactId: string;
  challengeId: string;
  data: SmsChallengeConfirmationBody;
};

export const useConfirmSms = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSms>>,
    TError,
    ConfirmSmsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmSms>>,
  TError,
  ConfirmSmsMutationVariables,
  TContext
> => {
  return useMutation(getConfirmSmsMutationOptions(options));
};
export const getConfirmEmailVerificationUrl = () => {
  return `/api/v1/contact-verifications/email/confirm`;
};

/**
 * @summary Confirm the pending email proof for the signed-in owner
 */
export const confirmEmailVerification = async (
  confirmEmailVerificationBody: ConfirmEmailVerificationBody,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<VerificationResultResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<VerificationResultResponseOutput>(getConfirmEmailVerificationUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(confirmEmailVerificationBody),
    schema: VerificationResultResponseOutput,
  });
};

export const getConfirmEmailVerificationMutationKey = () => ['confirmEmailVerification'] as const;

export const getConfirmEmailVerificationMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmEmailVerification>>,
    TError,
    ConfirmEmailVerificationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmEmailVerification>>,
  TError,
  ConfirmEmailVerificationMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmEmailVerificationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmEmailVerification>>,
    ConfirmEmailVerificationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return confirmEmailVerification(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmEmailVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmEmailVerification>>
>;
export type ConfirmEmailVerificationMutationBody = ConfirmEmailVerificationBody;
export type ConfirmEmailVerificationMutationError = void;
export type ConfirmEmailVerificationMutationVariables = { data: ConfirmEmailVerificationBody };

/**
 * @summary Confirm the pending email proof for the signed-in owner
 */
export const useConfirmEmailVerification = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmEmailVerification>>,
    TError,
    ConfirmEmailVerificationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmEmailVerification>>,
  TError,
  ConfirmEmailVerificationMutationVariables,
  TContext
> => {
  return useMutation(getConfirmEmailVerificationMutationOptions(options));
};
